// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl__BuildControl__AfSsY"};